import { problemTypes } from '../constants/ProblemTypes';

/* eslint-disable import/prefer-default-export */
/**
 * @param {object} solution
 * @param {string} method
 * prepare solution payload based on method
 */
export function prepareSolutionPayload(solution, method, testSlug) {
  const commonSolutionSetPayload = {
    test_slug: testSlug,
  };

  const commonSolutionPayload = {
    creator: solution.creator,
    problem: solution.problem,
    solution_type: solution.solution_type,
    test: solution.test,
    test_solution_set: solution.test_solution_set,
    test_slug: testSlug,
  };

  const editorSaveSolutionPayload = {
    code: solution.code,
    extra_data: solution.extra_data,
    technology: solution.technology,
    ...commonSolutionPayload,
  };

  const saveSolutionsPayload = {
    [problemTypes.MCQ]: {
      choice: solution.choice,
      ...commonSolutionPayload,
    },
    [problemTypes.FIB]: {
      choice: solution.choice,
      ...commonSolutionPayload,
    },
    [problemTypes.SUB]: {
      answer: solution.answer,
      attachments: solution.attachments,
      ...commonSolutionPayload,
    },
    [problemTypes.TEX]: {
      answer: solution.answer,
      ...commonSolutionPayload,
    },
    [problemTypes.DJP]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PFE]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PBE]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PFS]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PBT]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PBD]: {
      ...commonSolutionPayload,
    },
    [problemTypes.VID]: commonSolutionPayload,
    [problemTypes.ADO]: commonSolutionPayload,

    [problemTypes.FBE]: {
      file_based_data: solution.file_based_data,
      ...commonSolutionPayload,
    },
    [problemTypes.SCR]: editorSaveSolutionPayload,
    [problemTypes.DSC]: editorSaveSolutionPayload,
    [problemTypes.MLI]: editorSaveSolutionPayload,
    [problemTypes.SEL]: editorSaveSolutionPayload,
    [problemTypes.DBA]: editorSaveSolutionPayload,
    [problemTypes.UIX]: {
      ...commonSolutionPayload,
      technology: solution.technology,
    },
    [problemTypes.PRJ]: {
      ...commonSolutionPayload,
      technology: solution.technology,
    },
  };

  const editorUpdateMethodSolutionPayload = {
    code: solution.code,
    extra_data: solution.extra_data,
    technology: solution.technology,
    ...commonSolutionSetPayload,
  };

  const updateMethodSolutionPayload = {
    [problemTypes.MCQ]: {
      choice: solution.choice,
      ...commonSolutionSetPayload,
    },
    [problemTypes.FIB]: {
      choice: solution.choice,
      ...commonSolutionSetPayload,
    },
    [problemTypes.SUB]: {
      answer: solution.answer,
      attachments: solution.attachments,
      ...commonSolutionSetPayload,
    },
    [problemTypes.TEX]: {
      answer: solution.answer,
      ...commonSolutionSetPayload,
    },
    [problemTypes.FBE]: {
      file_based_data: solution.file_based_data,
      ...commonSolutionSetPayload,
    },
    [problemTypes.SCR]: editorUpdateMethodSolutionPayload,
    [problemTypes.DSC]: editorUpdateMethodSolutionPayload,
    [problemTypes.MLI]: editorUpdateMethodSolutionPayload,
    [problemTypes.SEL]: editorUpdateMethodSolutionPayload,
    [problemTypes.DBA]: editorUpdateMethodSolutionPayload,
    [problemTypes.UIX]: {
      ...commonSolutionPayload,
      technology: solution.technology,
    },
    [problemTypes.PRJ]: {
      ...commonSolutionPayload,
      technology: solution.technology,
    },
    [problemTypes.DJP]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PBE]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PFE]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PFS]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PBT]: {
      ...commonSolutionPayload,
    },
    [problemTypes.PBD]: {
      ...commonSolutionPayload,
    },
    [problemTypes.VID]: commonSolutionPayload,
    [problemTypes.ADO]: commonSolutionPayload,
  };

  const solutionObjectBasedOnMethod = {
    save: saveSolutionsPayload,
    update: updateMethodSolutionPayload,
  };

  return solutionObjectBasedOnMethod[method][solution.solution_type];
}

export const TIMEOUT_VALUE = 15000;
